import UmUpload from './src/main'

/* istanbul ignore next */
UmUpload.install = function(Vue) {
  Vue.component(UmUpload.name, UmUpload)
}

export default UmUpload
